export function articleDateInput(value = new Date()) {
  if (!value) return '';
  let input = value;
  if (typeof value === 'string') {
    input = value.replace(' ', 'T');
    if (input.includes('T') && !/(Z|[+-]\d{2}:?\d{2})$/i.test(input)) input += 'Z';
  }
  const date = new Date(input);
  if (Number.isNaN(date.getTime())) return '';
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Asia/Ulaanbaatar', year: 'numeric', month: '2-digit', day: '2-digit'
  }).formatToParts(date);
  const part = type => parts.find(item => item.type === type).value;
  return `${part('year')}-${part('month')}-${part('day')}`;
}
